import type { Dayjs } from "@eisox/dayjs";
import { cn, DateField, type DateFieldUnit, type DateRange } from "@eisox/design-system";

export interface PeriodFieldProps {
  value?: DateRange;
  onValueChange: (value: DateRange) => void;
  min?: Dayjs;
  max?: Dayjs;
  unit?: DateFieldUnit;
  className?: string;
}

export const PeriodField: React.FC<PeriodFieldProps> = ({ value, onValueChange, min, max, unit, className }) => (
  <DateField.Root
    mode="range"
    unit={unit}
    value={value}
    onValueChange={onValueChange}
    min={min}
    max={max}
    className={cn("w-full", className)}
  >
    <DateField.Input part="from" className="flex-1">
      <DateField.Trigger />
    </DateField.Input>
    <span className="text-primary-dark-gray">-</span>
    <DateField.Input part="to" className="flex-1">
      <DateField.Trigger />
    </DateField.Input>
    <DateField.Content className="z-1500 w-min select-none">
      <DateField.Calendar />
    </DateField.Content>
  </DateField.Root>
);

PeriodField.displayName = "PeriodField";
